import React from 'react';

import classNames from 'classnames';

const MyTitle = ({ children, small }) => (
  <h2 className={classNames('title', {
    'title-small': small
  })}>{children}</h2>
)

export default MyTitle;



// WEBPACK FOOTER //
// ./src/components/my-title.js